import { Injectable } from '@angular/core';

import { RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable, StateObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { saveCartState, saveTempState } from '../../localStorage';
import { NotificationFacade } from '../../notifications';
import { ShoppingCartFacade } from '../../shopping-cart/+state';
import { SwishService } from '../swish.service';
import { SwishActions } from './swish.actions';

@Injectable({
    providedIn: 'root',
})
export class SwishEpics implements RidangoEpic {
    constructor(
        private actions: SwishActions,
        private service: SwishService,
        private notifications: NotificationFacade,
        private cartFacade: ShoppingCartFacade
    ) { }

    register() {
        return [this.startTransaction];
    }

    startTransaction = (action$: ActionsObservable<any>) =>
        action$.ofType(SwishActions.START_TRANSACTION).pipe(
            switchMap((action: RidangoReduxAction) => {
                const cart = action.payload.cart;
                const paymentId = action.payload.paymentMethod.payment_id;
                const swichAccountId = action.payload.swishAccountId;

                return this.service.startSwishPayment(cart.shopping_cart_id, paymentId, swichAccountId).pipe(
                    map((response) => {
                        saveCartState(cart);
                        this.cartFacade.setCartStatus('L');
                        return this.actions.setTransactionData(response);
                    }
                    ),
                    catchError((e) => [this.actions.startTransactionFailed(e)])
                );
            })
        )
}

